import React from 'react'
import Form from 'react-bootstrap/esm/Form'

export default function BlockTypeVimeo({ blockType, blockContent, setBlockContent, lastError }) {
	return (
		<>
			{blockType === 'vimeo' && (
				<Form.Group className="mb-3">
					<Form.Label>URL del video dentro de Vimeo</Form.Label>
					<Form.Control
						type="text"
						placeholder="Ejemplo: https://vimeo.com/190594408"
						onChange={(e) => {
							setBlockContent({ id: e.target.value })
						}}
						value={blockContent.id}
						className={lastError === 'blockContent' && 'with-error'}
					/>
				</Form.Group>
			)}
		</>
	)
}
